type EntryPointProps = {
	host: string;
	pathname: string;
	search: string;
};

/**
 * Utility class for retrieving document referrer.
 */
export default class EntryPoint {
	/**
	 * Get document referrer.
	 *
	 * @returns The entry point as an object that contains host, pathname and search.
	 */
	public getEntryPoint(): EntryPointProps {
		const entryPoint = document.referrer;
		try {
			const url = new URL(entryPoint);
			return {
				host: url.host,
				pathname: url.pathname,
				search: url.search
			};
		} catch (e) {
			return undefined;
		}
	}
}
